import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Form from 'react-bootstrap/Form';
import { Button, Col, Container, Row, Spinner, OverlayTrigger, Popover } from 'react-bootstrap';
import ChemComponent from '../ChemComponent';
import ChemEdit from '../ChemEdit';
import { withRouter } from '../withRouter';
import QueryTable from '../QueryTable';

class EmailLists extends ChemComponent {
	constructor(props) {
		super(props);
		
		var search = {
			COC: [],
			SAME: false,
			CBE: [],
			CHEM: [],
			ORDER_BY: ['LAST_NAME','FIRST_NAME']
		};
		
		var emailListInit = this.copyTable(emailList);
		emailListInit.query.search = this.constructSearch(search);
		emailListInit.query.order = this.copyObject(search.ORDER_BY);

		this.state = {
			search: search,
			emailList: emailListInit,
			emailSearch: this.copyColumns(emailSearch),
			showSearch: false,
			searchCount: null,
			renderKey: 0
		};
	}

	onChangeSearch(accessor, value) {
		var newState = this.copyObject(this.state);
		this.setByAccessor(newState.search, accessor, value);
		
		if (accessor === 'SAME') {
			newState.emailSearch = this.copyColumns(emailSearch);
			if (value) {
				var chemIdx = this.findColumnByAccessor(newState.emailSearch, 'CHEM');
				var cbeIdx = this.findColumnByAccessor(newState.emailSearch, 'CBE');
				newState.emailSearch[cbeIdx].Header +=
					'<br />-and-<br />' +
					newState.emailSearch[chemIdx].Header;
				newState.emailSearch.splice(chemIdx, 1);
			}
		}
				
		this.setState(newState);
	}

	constructSearch(dataArg) {
		var i;
		
		// copy the data and int-ify all the arrays becuase we are dumb
		var data = this.copyObject(dataArg);
		
		// if nothing at all is selected, return null
		if (data.COC.length === 0 && data.CBE.length === 0 && (data.SAME || data.CHEM.length === 0)) return null;

		for (i = 0; i < data.COC.length; i++) data.COC[i] = +data.COC[i];
		for (i = 0; i < data.CBE.length; i++) data.CBE[i] = +data.CBE[i];
		for (i = 0; i < data.CHEM.length; i++) data.CHEM[i] = +data.CHEM[i];
		
		// construct search terms
		var search = {
			Operator: 'or',
			Children: []
		};

		// add coc clauses
		if (data.COC.includes(0)) {
			// select entire college
			search.Children.push(clauses.college[0]);
		} else {
			// disjunction of selected clauses except 'All'
			var coc = { Operator: 'or', Children: [] };
			
			// add each clause that is not 'All'
			for (i = 0; i < data.COC.length; i++) {
				if (+data.COC[i] !== 0) coc.Children.push(clauses.college[data.COC[i]]);
			}
			
			// if any clauses were added
			if (coc.Children.length > 0) {
				// conjunction with 'in the college'
				search.Children.push({ Operator: 'and', Children: [clauses.college[0],coc]});
			}
		}
		
		// copy "whole department" clause
		var cbeDept = this.copyObject(clauses.department[0]);
			
		// set dept. id
		cbeDept.StringValue = '|2|';

		// add cbe columns
		if (data.CBE.includes(0)) {
			// select entire department
			search.Children.push(cbeDept);
		} else {
			// disjunction of selected clauses except 'All'
			var cbe = { Operator: 'or', Children: [] };
			
			// add each clause that is not 'All'
			for (i = 0; i < data.CBE.length; i++) {
				if (data.CBE[i] !== 0) cbe.Children.push(clauses.department[data.CBE[i]]);
			}
			
			// if any clauses were added
			if (cbe.Children.length > 0) {
				// conjunction with 'in the department'
				search.Children.push({ Operator: 'and', Children: [cbeDept,cbe]});
			}
		}
		
		// copy "whole department" clause
		var chemDept = this.copyObject(clauses.department[0]);
			
		// set dept. id
		chemDept.StringValue = '|1|';
		
		// use cbe or chem depending on "same" checkbox
		var data_CHEM = data.SAME ? data.CBE : data.CHEM;
		
		// add cbe columns
		if (data_CHEM.includes(0)) {
			// select entire department
			search.Children.push(chemDept);
		} else {
			// disjunction of selected clauses except 'All'
			var chem = { Operator: 'or', Children: [] };
			
			// add each clause that is not 'All'
			for (i = 0; i < data_CHEM.length; i++) {
				if (data_CHEM[i] !== 0) chem.Children.push(clauses.department[data_CHEM[i]]);
			}
			
			// if any clauses were added
			if (chem.Children.length > 0) {
				// conjunction with 'in the department'
				search.Children.push({ Operator: 'and', Children: [chemDept,chem]});
			}
		}
		
		// if no top-level clauses were added, forget it
		if (search.Children.length === 0) return null;
		return search;
	}
	
	onExpandSearch(event) {
		this.mergeState({
			showSearch: true,
			renderKey: this.state.renderKey + 1
		});
		if (event && event.nativeEvent && event.nativeEvent.submitter) event.nativeEvent.submitter.blur();		
	}

	onSubmitSearch(event, newOrderBy) {
		// copy search in case we need to incorporate the new ordering
		var search = this.copyObject(this.state.search);
		var newEmailList = this.copyTable(emailList);
		newEmailList.query.search = this.constructSearch(search);
		if (newOrderBy) {
			search.ORDER_BY = this.copyObject(newOrderBy);
			newEmailList.query.order = this.copyObject(newOrderBy);
		}
		
		this.mergeState({
			search: search,
			emailList: newEmailList,
			showSearch: false,
			searchCount: null,
			renderKey: this.state.renderKey + 1
		});
	}
	
	onSearchResult(data) {		
		this.mergeState({
			searchCount: data.ResultCount,
		});
	}
	
	render() {
		
		var exportData = this.createHiddenFormData({
			__RequestVerificationToken: this.props.user.antiForgeryToken,
			title: 'Email List',
			columns: exportColumns,
			entity: 'COLLEGE.EMAIL_LIST_GEN_VW',
			search: this.constructSearch(this.state.search),
			order: this.state.search.ORDER_BY
		});			
		
		var emailData = this.createHiddenFormData({
			__RequestVerificationToken: this.props.user.antiForgeryToken,
			title: 'Mailing List',
			distinct: true,
			columns: ['EMAIL'],
			entity: 'EMAIL_LIST_GEN_VW',
			search: this.constructSearch(this.state.search),
			order: ['EMAIL']
		});

		return (<>
			<Container fluid>
			  <Row>
			    <Col style={{ paddingTop: '20px', marginBottom: '20px', border: '1px solid #ccc', borderRadius: 6, backgroundColor: '#FEFEFE' }}>
				  <Container fluid>	
					<Row>
					  <Col xs={12}>
						<div style={{ fontSize: '18px', fontWeight: 'bold', marginBottom: '4px' }}>Generate Email Address Lists</div>
						{this.state.showSearch && <>
						  If nothing is selected, emails will be retrieved for all units and departments.
						  <ChemEdit parent={this} user={this.props.user} columns={this.state.emailSearch} data={this.state.search}
							renderKey={this.state.renderKey} onChange={(accessor, value) => this.onChangeSearch(accessor, value)} />
						</>}
					  </Col>
					</Row>
					<Form.Group as={Row} style={{ borderTop: '1px solid #eee', paddingTop: 10, marginBottom: 10 }}>
					  <Col xs={3} style={{ marginTop: 8}}>
						{this.isEmpty(this.state.searchCount) ? <Spinner animation='border' as='div' size='sm' style={{ marginRight: '4px' }} /> : this.state.searchCount} records found.
					  </Col>
					  <Col xs={1} style={{ marginTop: 6}}>
						<form action={this.getConfig().host + '/Home/Excel'} method='POST'>
							{exportData.map((excelFormField, index) => {
								return (<input key={index} type='hidden' name={excelFormField.name} value={excelFormField.value} />);
							})}
							<OverlayTrigger trigger="hover" overlay={<Popover><Popover.Header as="h3">Export to Excel</Popover.Header></Popover>}>
							  <input type='image' src={this.getConfig().host + '/Content/Icons/Excel.png'} style={{ paddingLeft: '20px' }} alt="Export to Excel" />
							</OverlayTrigger>
						</form>
					  </Col>
					  <Col xs={1} style={{ marginTop: 6}}>
						<form action={this.getConfig().host + '/Home/Pdf'} method='POST'>
							{exportData.map((pdfFormField, index) => {
								return (<input key={index} type='hidden' name={pdfFormField.name} value={pdfFormField.value} />);
							})}
							<OverlayTrigger trigger="hover" overlay={<Popover><Popover.Header as="h3">Export to PDF</Popover.Header></Popover>}>
							  <input type='image' src={this.getConfig().host + '/Content/Icons/Pdf.png'} style={{ paddingLeft: '20px' }} alt="Export to PDF" />
							</OverlayTrigger>
						</form>
					  </Col>
					  <Col xs={1} style={{ marginTop: 6}}>
						<form action={this.getConfig().host + '/Home/MailingList'} method='POST'>
						  {emailData.map((emailFormField, index) => {
							return (<input key={index} type='hidden' name={emailFormField.name} value={emailFormField.value} />);
						  })}
						  <OverlayTrigger trigger="hover" overlay={<Popover><Popover.Header as="h3">Export Email List</Popover.Header></Popover>}>
							<input type='image' src={this.getConfig().host + '/Content/Icons/Email.png'} style={{ paddingLeft: '20px' }} alt="Export Email List" />
						  </OverlayTrigger>
						</form>
					  </Col>
					  <Col xs={6}>
						{this.state.showSearch ?
							<Button id="update" variant="warning" type="button" className="float-end" onClick={(event) => this.onSubmitSearch(event)}>Search</Button> :
							<Button id="expand" variant="warning" type="button" className="float-end" onClick={(event) => this.onExpandSearch(event)}>Modify Search</Button>
						}
					  </Col>
					</Form.Group>
				  </Container>
				</Col>
			  </Row>
			  <Row>
				<Col>
				  <QueryTable renderKey={this.state.renderKey} parent={this} name='Contact_Email' table={this.state.emailList}
				    order={this.state.search.ORDER_BY} onTableSort={(newOrder) => this.onSubmitSearch(null, newOrder)}
				    onResult={(data) => this.onSearchResult(data)} offsetHeight='140px' />
				</Col>
			  </Row>
			</Container>
		</>);		
	}
}

const clauses = {
	college: [ 
		{ Attribute: 'DEPT_ID', Operator: 'like', StringValue: '%|10|%' },
		{ Attribute: 'WORK_TITLE', Operator: 'in', LongList: [2,4,5,37,45,67,68] },
		{ Attribute: 'WORK_TITLE', Operator: 'in', LongList: [3,9,10,11,12,48,49] }, 
		{ Attribute: 'WORK_TITLE', Operator: 'in', LongList: [8,32,34,40,44,46,51,56,60,62,63] },
		{ Attribute: 'UNIT_ID', Operator: '=', LongValue: 15 },
		{ Attribute: 'UNIT_ID', Operator: '=', LongValue: 42 },
		{ Attribute: 'UNIT_ID', Operator: '=', LongValue: 30 }
	],
	department: [
		{ Attribute: 'DEPT_ID', Operator: 'like', StringValue: '' },
		{ Attribute: 'WORK_TITLE', Operator: 'in', LongList: [22,27,74,88] },
		{ Attribute: 'WORK_TITLE', Operator: 'in', LongList: [17,58,59,65] },
		{ Attribute: 'UNIT_ID', Operator: '=', LongValue: 13 },
		{ Attribute: 'WORK_TITLE', Operator: 'in', LongList: [29, 23, 21] },
		{ Attribute: 'UNIT_ID', Operator: '=', LongValue: 1 },
		{ Attribute: 'TYPE_ID', Operator: 'in', LongList: [2,9] },
		{ Attribute: 'TYPE_ID', Operator: '=', LongValue: 17 },
		{ Attribute: 'TYPE_ID', Operator: '=', LongValue: 10 },
		{ Attribute: 'TYPE_ID', Operator: '=', LongValue: 11 },
		{ Attribute: 'TYPE_ID', Operator: 'in', LongList: [3,27] },
		{ Attribute: 'SUPERVISOR_FLAG', Operator: '=', StringValue: 'Y' },
		{ Attribute: 'TYPE_ID', Operator: 'in', LongList: [18,19,24] },
		{ Attribute: 'TYPE_ID', Operator: 'in', LongList: [25,26,27] }
	]
};

const emailSearch = [
	{ Header: 'College of Chemistry', accessor: 'COC', type: 'list',
		options: [
			{ value: 0, label: 'All' },
			{ value: 1, label: 'Analytical Facilites' },
			{ value: 2, label: 'Business Administration & Financial Services' },
			{ value: 3, label: 'College Engineering & Facilities' },
			{ value: 4, label: 'College Relations' },
			{ value: 5, label: "Dean's Office" },
			{ value: 6, label: 'Undergraduate Advising' }
		]
	},
	{ Header: 'Use same selections for CBE and Chemistry', accessor: 'SAME', type: 'checkbox' },
	{ Header: 'Chemical Biomolecular Engineering', accessor: 'CBE', type: 'list',
		options: [
			{ value: 0, label: 'All' },
			{ value: 1, label: 'Academic Personnel' },
			{ value: 2, label: "Chair's Office" },
			{ value: 3, label: 'FSA' },
			{ value: 4, label: 'Graduate Student Office' },
			{ value: 5, label: 'Instructional Support Operations' },
			{ value: 6, label: 'Faculty' },
			{ value: 7, label: 'Lecturers' },
			{ value: 8, label: 'Graduate Students' },
			{ value: 9, label: 'Postdocs' },
			{ value: 10, label: 'Staff' },
			{ value: 11, label: 'Staff Managers and Supervisors' },
			{ value: 12, label: 'Visiting Scholars and Visiting Researchers' },
			{ value: 13, label: 'Specialists, Project Scientists, and Professional Researchers' }
		]
	},	
	{ Header: 'Chemistry', accessor: 'CHEM', type: 'list',
		options: [
			{ value: 0, label: 'All' },
			{ value: 1, label: 'Academic Personnel' },
			{ value: 2, label: "Chair's Office" },
			{ value: 3, label: 'FSA' },
			{ value: 4, label: 'Graduate Student Office' },
			{ value: 5, label: 'Instructional Support Operations' },
			{ value: 6, label: 'Faculty' },
			{ value: 7, label: 'Lecturers' },
			{ value: 8, label: 'Graduate Students' },
			{ value: 9, label: 'Postdocs' },
			{ value: 10, label: 'Staff' },
			{ value: 11, label: 'Staff Managers and Supervisors' },
			{ value: 12, label: 'Visiting Scholars and Visiting Researchers' },
			{ value: 13, label: 'Specialists, Project Scientists, and Professional Researchers' }
		]
	}
];

const emailList = {
	query: { entity: 'COLLEGE.EMAIL_LIST_GEN_VW', search: null, order: ['LAST_NAME','FIRST_NAME'] },
	pageSize: 20,
	columns: [
		{ Header: 'Last Name', accessor: 'LAST_NAME', width: 125 },
		{ Header: 'First Name', accessor: 'FIRST_NAME', width: 125 },
		{ Header: 'Email', accessor: 'EMAIL', width: 300 },
		{ Header: 'Phone', accessor: 'PHONE', width: 125 },
		{ Header: 'Appointment Type', accessor: 'TYPE_NAME', width: 250 },
		{ Header: 'Affiliation', accessor: 'AFFILIATION', width: 300 },
		{ Header: 'Department', accessor: 'DEPARTMENT', width: 300 }
	]
};

const exportColumns = [
	{ Header: 'Last Name', accessor: 'LAST_NAME', width: 25 },
	{ Header: 'First Name', accessor: 'FIRST_NAME', width: 25 },
	{ Header: 'Email', accessor: 'EMAIL', width: 60 },
	{ Header: 'Phone', accessor: 'PHONE', width: 25 },
	{ Header: 'Appointment Type', accessor: 'TYPE_NAME', width: 50 },
	{ Header: 'Affiliation', accessor: 'AFFILIATION', width: 60 },
	{ Header: 'Department', accessor: 'DEPARTMENT', width: 60 }
];

export default withRouter(EmailLists);
